import * as React from "react";
import { Box } from "@mui/material";
import {formatDate} from "@ui-seeker/utils";

import { NotAllowedBlock } from "@components";

export default function dateColumn(name, label, visibility) {
	return [{
		name, label,
		options: {
			display: 'excluded',
			customBodyRowRender: (value) => {
				if (value === null) return 'N/A'
				return 'Yes'
			}
		}
	},{
		name, label,
		options: {
			filter: false,
			display: visibility,
			customBodyRowRender: (value) => {
				return <Box sx={{ textAlign:'center' }}>
					{!!value ? formatDate(value, { isString: true }) : <NotAllowedBlock />}
				</Box>
			}
		}
	}]
}